(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-menu-accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  const link = event.target.closest('.drawer__inner a');
  if (!link) return;

  const href = link.getAttribute('href');
  if (!href) return;

  const linkUrl = new URL(href, window.location.origin);
  const current = window.location;

  const isSamePage = linkUrl.pathname === current.pathname;
  const isAnchor = href.startsWith('#') || linkUrl.hash !== '';

  if (isSamePage || isAnchor) {
    const drawerElement = link.closest('header-drawer');
    
    setTimeout(() => {
      // 1. Hitta alla öppna details-element (accordions) inuti menyn och stäng dem
      const openAccordions = document.querySelectorAll('.drawer__inner details[open]');
      openAccordions.forEach(details => {
        details.removeAttribute('open');
      });

      // 2. Stäng själva huvudmenyn
      if (drawerElement && typeof drawerElement.close === 'function') {
        drawerElement.close();
      } else {
        const closeBtn = document.querySelector('.drawer__close');
        if (closeBtn) closeBtn.click();
      }
    }, 10);
  }
});

  } catch(e) { console.error(e); }
})();
})();
